define 'controller/InputStrengthController', ['jquery', 'lib/kryptonite', 'lib/easy-autocomplete'], ($) ->
  class InputStrengthController

    constructor: (@$el) ->
      @_passwordStrengthCheck()

      $("body").on "password-strength", @_passwordStrength

    _passwordStrength: ->
      console.log("password-strength registered")
      if $('.js-checkPasswordStrength').length
        upperCase= ".*[A-Z].*"
        numbers = ".*\\d.*"
        specialChars = ".*[^A-Za-z 0-9].*"
        pass = $('.js-checkPasswordStrength').val()

        if pass.length >= 8
          $('.registration__password-strength .characterTotal').addClass('positive')
          $('.registration__password-strength .characterTotal').removeClass('negative')
          passcheckLength = 1
        else
          $('.registration__password-strength .characterTotal').removeClass('positive')
          $('.registration__password-strength .characterTotal').addClass('negative')
          passcheckLength = 0

        if pass.match(upperCase)
          $('.registration__password-strength .uppercase').addClass('positive')
          $('.registration__password-strength .uppercase').removeClass('negative')
          passcheckUppercase = 1
        else
          $('.registration__password-strength .uppercase').removeClass('positive')
          $('.registration__password-strength .uppercase').addClass('negative')
          passcheckUppercase = 0

        if pass.match(numbers)
          $('.registration__password-strength .number').addClass('positive')
          $('.registration__password-strength .number').removeClass('negative')
          passcheckNumbers = 1
        else
          $('.registration__password-strength .number').removeClass('positive')
          $('.registration__password-strength .number').addClass('negative')
          passcheckNumbers = 0

        if pass.match(specialChars)
          $('.registration__password-strength .specialChar').addClass('positive')
          $('.registration__password-strength .specialChar').removeClass('negative')
          passcheckSpecialChars = 1
        else
          $('.registration__password-strength .specialChar').removeClass('positive')
          $('.registration__password-strength .specialChar').addClass('negative')
          passcheckSpecialChars = 0

        if passcheckLength == 1 && passcheckUppercase == 1 && passcheckNumbers == 1 && passcheckSpecialChars == 1
          $('.registration__password-strength__result .password-fail').hide()
          $('.registration__password-strength__result .password-success').show()
        else
          $('.registration__password-strength__result .password-success').hide()
          $('.registration__password-strength__result .password-fail').show()

      return

    _colorInfobox: ->
      listItems = document.querySelectorAll('.registration__password-strength--list li')
      hasNegative = false
      allPositive = true

      listItems.forEach (li) ->
        if li.classList.contains('negative')
          hasNegative = true
          allPositive = false
        if not li.classList.contains('positive')
          allPositive = false

      if allPositive
        $('.registration__password-strength').addClass("allPositive");
        $('.registration__password-strength').removeClass("notAllPositive");

      else if hasNegative
        $('.registration__password-strength').addClass("notAllPositive");
        $('.registration__password-strength').removeClass("allPositive");


    _passwordStrengthCheck: ->
      self = @
      inputElement = $('.js-checkPasswordStrength')
      if inputElement.val()
        self._passwordStrength()
        $('.registration__password-strength__result').removeClass('registration__hide-line')
        self._colorInfobox()

      inputElement.on 'keypress keyup keydown ', ->
        self._passwordStrength()
        $('.registration__password-strength__result').removeClass('registration__hide-line')
        self._colorInfobox()
